module.exports = __webpack_public_path__ + "img/pIndex-wx.ab58bed4.png";